/**
 * CheckoutSteps Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import CheckoutStepBilling from './CheckoutStepBilling';
import CheckoutStepLicense from './CheckoutStepLicense';
import CheckoutStepProject from './CheckoutStepProject';
import CheckoutStepReview from './CheckoutStepReview';

const classes = new BEM('checkout__steps');

interface IOwnProps {
  companyTypes: GQL.ICompanyTypeConnection;
  representativeRoles: GQL.IRepresentativeRoleConnection;
  order: GQL.IOrder;
}

export default function CheckoutSteps({ companyTypes, order, representativeRoles }: IOwnProps) {
  return (
    <div {...classes('') }>
      <CheckoutStepProject order={order} />
      <CheckoutStepLicense representativeRoles={representativeRoles} />
      <CheckoutStepBilling />
      <CheckoutStepReview
        companyTypes={companyTypes}
        order={order}
        representativeRoles={representativeRoles}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutSteps.tsx